import React, { useContext, useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import {AppContext } from "../../AppContext";
import { LogInfo } from "../../common/FetchHelpers";


const LogoutComp = () => {
  const location = useLocation();
  const [appContext,setAppContext] = useContext(AppContext);
  //console.log('Rendering LogoutComp() from '+location.pathname);
  
  useEffect(() => {
    //console.log('--LogoutComp.useEffect()--'+location.pathname);
      if(location.pathname === '/logout'){
        //console.log('LogoutComp.useEffect(): clearing local stoage except sso logout url');
        localStorage.removeItem("TOKEN");
        localStorage.removeItem("TOKENINFO");
        localStorage.removeItem("USER");    
        localStorage.removeItem("SSO_LOGIN_URL");
        // localStorage.removeItem("SSO_LOGOUT_URL");
        localStorage.removeItem("CLIENT_ID");
        localStorage.removeItem("NOTIFICATION_COUNT");
        
        //console.log('LogoutComp.useEffect(): clearing app context');
        setAppContext({
            ...appContext,
            auth: false,
            user: {},
            token:null
        });
    }
    else{
      //console.log('LogoutComp.useEffect(): nothing to cleanup');
    }
  }, []);
  
  if(location.pathname === '/logout'){
    LogInfo('cleanup done routing to /afterlogout');
    return (<Redirect to='/afterlogout' />)
  }
  else{
    const ssoLogoutUrl = localStorage.getItem("SSO_LOGOUT_URL")|| "";
    if(ssoLogoutUrl  && ssoLogoutUrl !== ""){
      localStorage.removeItem("SSO_LOGOUT_URL");
      LogInfo('SSO is enabled --> Redirecting to ssoURL '+ssoLogoutUrl);
      window.location.replace(ssoLogoutUrl);
      return (null);
    }
    else{
      LogInfo('No SSO ==> routing to app Login page');
      return (<Redirect to='/login' />);
    } 
  }

};

export default LogoutComp;
